<template>
    <div class="mb-5">

        <div class="my-2 d-flex flex-row justify-content-between">
            <div>
                <a class="btn btn-secondary" :href="calendarPage"><i class="fa fa-fw fa-arrow-left"></i> Calendar</a>
            </div>
        </div>
        <div v-if="Object.keys(eventTimeList).length > 0">
            <div v-for="(timeArr, day) in eventTimeList" :key="day.toString()" class="row mb-2">
                <p class="p-3 bg-success text-center font-size-lg text-white fw-semibold">{{ day }}</p>

                <div class="row item-push" v-if="timeArr['appointment'] && timeArr['appointment'].length">
                    <h5><span class="badge rounded-pill bg-info">Appointments</span></h5>
                    <div class="col-6 col-md-6 col-xl-3" v-for="(time, i) in timeArr['appointment']"
                         :key="`appointment-${i}`">
                        <div class="block block-rounded shadow bg-body-dark">
                            <div class="block-header block-header-default">
                                <h3 class="block-title">
                                    Meeting <small>({{ expertName }})</small>
                                </h3>
                                <div class="block-options">
                                    <button class="btn btn-sm btn-outline-warning" type="button"
                                            @click="cancelMeeting(time.eventId)">Cancel
                                    </button>
                                </div>
                            </div>
                            <div class="block-content">
                                <p>{{ time.start }} - {{ time.end }} ({{ userZone }})</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row item-push" v-if="timeArr['available'] && timeArr['available'].length">
                    <h5><span class="badge rounded-pill bg-info">Availabilities</span></h5>
                    <div class="col-6 col-md-4 col-xl-2" v-for="(time, i) in timeArr['available']"
                         :key="`available-${i}`">
                        <div class="form-check form-block">
                            <input type="radio" class="form-check-input" v-model="checkedAvail"
                                   :value="parseInt(time.eventId)"
                                   :id="`avail-radio-${time.eventId}`" name="avail-radio">
                            <label class="form-check-label" :for="`avail-radio-${time.eventId}`">
                            <span class="d-block fw-normal text-center my-3">
                              <span class="d-block fs-2 fw-light py-3 m-3 bg-body-light rounded">{{
                                      time.start
                                  }} - {{ time.end }} ({{ userZone }})</span>
                              <span class="d-block mb-2">
                                  <button type="button" class="btn btn-sm btn-danger" @click="deleteAvailability(time)"><i
                                      class="fas fa-trash-alt"></i> Delete Availability</button>
                              </span>
                            </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 mx-auto d-grid gap-2">
                    <button class="btn btn-primary" @click="previewMeetingInviteEmail(checkedAvail)">Create
                        Appointment
                    </button>
                </div>
            </div>
        </div>
        <div v-else>
            No Availability existed
        </div>
    </div>
</template>

<script>
import calendar from '../mixins/calendar'

export default {
    name: 'AlphaCalendarAvailability',
    props: {
        'assignmentId': {
            type: Number,
            required: true,
        },
        'userZone': {
            type: String,
        },
        'expertName': {
            type: String,
        },
        'calendarPage': {
            type: String,
        },
        'projectTitle': {
            type: String,
        },
    },
    mixins: [calendar],
    data: () => ({
        checkedAvail: null,
    }),
    computed: {
        availableList () {
            return this.$store.getters['events/events']
        },
        eventTimeList () {
            return this.generateEventTimeList(this.availableList, this.userZone)
        },
    },
    methods: {
        previewMeetingInviteEmail (eventId) {
            if (eventId === null) {
                alert('Please select an availability')
                return false
            }

            window.location.href = `/admin/email/online-meeting-invite/preview/${eventId}`
        },
        fetchAvailabilities () {
            this.$store.dispatch('events/getEvents', {
                id: this.assignmentId,
                zone: this.userZone,
                expertName: this.expertName,
                projectTitle: this.projectTitle,
            })
        },
        cancelMeeting (eventId) {
            window.location.href = `/admin/assignment/new-calendar/cancel-meeting/${eventId}?assignment_id=${this.assignmentId}`
        },
    },
    mounted () {
        this.$nextTick(function () {
            this.fetchAvailabilities()
        })
    },
}
</script>

<style scoped>

</style>
